import React from 'react'
import PropTypes from 'prop-types'
// import { StaticQuery, graphql } from 'gatsby'

import Head from './head'
import Navbar from './nav'
import SEO from './seo'
import Footer from './footer'

const Layout = ({
  title,
  nav_class,
  nav_logo,
  nav_menu,
  seo,
  bg,
  children,
}) => (
  <div className="wrapper">
    <Head />
    <Navbar extra_class={nav_class} logo={nav_logo} menu={nav_menu} />
    {/* look for provided seo component, use default otherwise */}
    {seo ? seo : <SEO title={title} />}
    <div className="content" style={{ background: bg }}>
      {children}
    </div>
    <Footer />
  </div>
)

Layout.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  nav_logo: PropTypes.string,
  nav_menu: PropTypes.arrayOf(PropTypes.object),
  seo: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default Layout
